import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/ball117.svg'
import _imports_1 from '@/assets/images/hourglass.svg'


const _withScopeId = n => (_pushScopeId("data-v-30f9ad6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "section-header p-flex-wrap p-grid"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "p-col-12 head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between p-flex-wrap" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "infl-profile p-d-flex p-flex-wrap p-ai-center" })
  ])
], -1))
const _hoisted_4 = { class: "center-block" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "p-d-flex ended-border"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"ball-block\" data-v-30f9ad6d><img class=\"ball-sm\" src=\"" + _imports_0 + "\" data-v-30f9ad6d><img class=\"ball-md\" src=\"" + _imports_0 + "\" data-v-30f9ad6d><img class=\"ball\" src=\"" + _imports_0 + "\" data-v-30f9ad6d><img class=\"ball-lg\" src=\"" + _imports_0 + "\" data-v-30f9ad6d></div><div class=\"decoration\" data-v-30f9ad6d><img src=\"" + _imports_1 + "\" data-v-30f9ad6d></div><div class=\"ended\" data-v-30f9ad6d>Become part of the Advanced Licensing program for content creators now!</div><div class=\"ended-small\" data-v-30f9ad6d> This is an exclusive limited time offer for invited influencers only!</div>", 4)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"p-d-flex ended-border\" data-v-30f9ad6d><div class=\"ended\" data-v-30f9ad6d> We are constantly updating our means of tracking fraudulent/illicit conversion generation so please make sure that you are always adhering to the GIO terms and conditions regarding natural conversions when taking part in our campaigns or you will risk being removed from the platform and further repercussions. </div></div><div class=\"p-d-flex ended-border\" data-v-30f9ad6d><div class=\"ball-block\" data-v-30f9ad6d><img class=\"ball-sm\" src=\"" + _imports_0 + "\" data-v-30f9ad6d><img class=\"ball-md\" src=\"" + _imports_0 + "\" data-v-30f9ad6d><img class=\"ball\" src=\"" + _imports_0 + "\" data-v-30f9ad6d><img class=\"ball-lg\" src=\"" + _imports_0 + "\" data-v-30f9ad6d></div><div class=\"decoration\" data-v-30f9ad6d><div class=\"material-icons discord-icon\" data-v-30f9ad6d>discord</div></div><div class=\"ended\" data-v-30f9ad6d> Make sure to join our discord to be the first to know about <b data-v-30f9ad6d>new campaigns, offers and rate increases.</b></div><a target=\"_blank\" href=\"https://discord.gg/e8pVGfK8X3\" class=\"get-button\" data-v-30f9ad6d>Join</a></div>", 2)
const _hoisted_13 = { class: "welcome p-ml-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "color-text paragraph-inf p-ml-6" }, "From here you can check out creators, content items, running campaigns or create a new campaign!", -1))
const _hoisted_15 = { class: "search-section-bottom p-col-12 p-grid" }
const _hoisted_16 = { class: "p-input-icon-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_license_influencer = _resolveComponent("license-influencer")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_terms_modal = _resolveComponent("terms-modal")!

  return ($props.user)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("section", _hoisted_4, [
          (!$props.user.isBrandOwner())
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (!$setup.aMember && !$props.user?.creatorAgreeSiteRiles)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", {
                        class: "get-button",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showLicense = true))
                      }, "Get it now"),
                      _createVNode(_component_license_influencer, {
                        onCloseLicenseModal: $setup.closeAndOpen,
                        show: $setup.showLicense,
                        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.showLicense) = $event))
                      }, null, 8, ["onCloseLicenseModal", "show"])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h1", _hoisted_13, "Welcome Back, " + _toDisplayString($props.user?.name || '') + "!", 1),
          _hoisted_14
        ]),
        _createElementVNode("section", _hoisted_15, [
          _createVNode(_component_Dropdown, {
            modelValue: $setup.typeSearch,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.typeSearch) = $event)),
            options: $props.viewPerspective === $setup.Perspective.CREATOR || $props.viewPerspective === $setup.Perspective.AGENCY
       ? $setup.typeSearchOptionsCreator : $setup.typeSearchOptionsBrand,
            optionLabel: "value",
            optionValue: "value",
            class: "p-mr-3 inputs-default bolder-input",
            style: {"min-width":"150px"}
          }, null, 8, ["modelValue", "options"]),
          _createElementVNode("span", _hoisted_16, [
            _createElementVNode("i", {
              class: "pi pi-search",
              style: _normalizeStyle($props.viewPerspective === $setup.Perspective.BRAND ? 'top: 25%' : 'top: 48%')
            }, null, 4),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: $setup.searchValueInput,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchValueInput) = $event)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.searchMethod($setup.searchValueInput, $setup.typeSearch))),
              placeholder: "Search for anything",
              class: "inputs-default search"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_terms_modal, {
              show: $setup.showTerms,
              "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (($setup.showTerms) = $event)),
              onCloseModal: $setup.closeTermsModal
            }, null, 8, ["show", "onCloseModal"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}